<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Devoluciones
    v-dialog(v-model='dialog3', persistent max-width='70%')
      v-card
        v-card-text
          v-container(id="printJS-form")
            div(align='center')
              h4(style='font-weight: 700 !important;') DEVOLUCIÓN
            br
            div(style='display: flex;justify-content: space-between;align-items: center;')
              img(src='../assets/logo.png', style='height: auto;width: 90px;object-fit:contain;')
              table(border="0" align="center")
                tr
                  td(align='end').withTd
                    span.paddText N° DEVOLUCIÓN
                  td.borderTb
                    span.withTd3 {{form.nro}}
                tr
                  td(align='end').withTd
                    span.paddText FECHA
                  td.borderTb
                    span.withTd3 {{form.fecha}}
                tr(v-if='form.papeleta')
                  td(align='end').withTd
                    span.paddText N° TALONARIO
                  td.borderTb
                    span.withTd3 {{form.papeleta}}
            div(style='margin-top:20px;display: flex;flex-direction: column;')
              span(v-if='form.cliente').withTd5 CLIENTE: {{form.cliente.cli_des.trim()}}
              span(v-if='form.cliente').withTd5 RIF: {{form.cliente.rif.trim()}}
              span(v-if='form.vendedor').withTd5 VENDEDOR: {{form.vendedor.ven_des.trim()}}
              span(v-if='form.motivo').withTd5 MOTIVO: {{form.motivo}}
              span(v-if='form.referencia').withTd5 REFERENCIA: {{form.referencia}}
              span(v-if='form.factura').withTd5 FACTURA: {{form.factura.nro_doc}}
              span(v-if='form.factura').withTd5 FECHA FACTURA: {{form.factura.fecha}}
              span(v-if='form.descripcion').withTd5 COMENTARIO: {{form.descripcion}}
            table(border="0" align="center" style='width: 100%;margin-top:20px;')
              tr
                td(align='center').withTd4
                  span.white--text CÓDIGO
                td(align='center').withTd4
                  span.white--text NOMBRE
                td(align='center').withTd4
                  span.white--text PRECIO
                td(align='center').withTd4
                  span.white--text CANTIDAD
                td(align='center').withTd4
                  span.white--text TOTAL
              tr(v-for='item in form.arts')
                td(align='center').withTd2
                  span {{item.co_art}}
                td(align='center').withTd2
                  span {{item.art_des}}
                td(align='center').withTd2
                  span {{item.prec_vta}}
                td(align='center').withTd2
                  span {{item.cantNew}}
                td(align='center').withTd2
                  span {{item.total}}
              tr
                td(align='center').withTd3
                td(align='center').withTd3
                td(align='center').withTd3
                td(align='center').withTd3
                  span TOTAL
                td(align='center').withTd3
                  span ${{form.total}}

            div(v-if='form.images && form.images.length > 0').divCli
              span IMAGENES
            table(v-if='form.images && form.images.length > 0' border="0" align="center" style='width: 100%;margin-top:10px;')
              tr
                td(align='center' v-for='item in form.images')
                  div(style='margin:5px;')
                    img(:src='ruta + item', style='height: 250px;object-fit: contain;width: auto;')

            div(style="margin-top:30px;")
              span.withTd5 Nota: La recepción de la misma no asegura su aprobación (las devoluciones y cambios son estableciadas acorde a la políticas de la empresa)

        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close3()')
            v-icon mdi-close
            | Salir
          v-btn(color='success' small dark @click="imprimirPdf()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.nro"
                            prepend-inner-icon="description"
                            label="Nro.:")
                            
                            v-text-field(outline
                            readonly
                            v-if='form.vendedor'
                            v-model="form.vendedor.ven_des"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            v-if='form.cliente'
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.factura'
                            readonly
                            v-model="form.factura.nro_doc"
                            prepend-inner-icon="description"
                            label="Factura:")

                            div(v-if='form.productos.length > 0')
                                v-card(style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                                    v-card-title.justify-center
                                        span PRODUCTOS
                                v-layout(align-start='', justify-start='', row='', fill-height='' style='border-bottom: 1px solid #dcd7d7;padding-bottom: 15px;')
                                    v-flex(xs8)
                                        span(style='font-weight: bold;font-size: 14px;') NOMBRE
                                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-weight: bold;font-size: 14px;') CANTIDAD
                                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-weight: bold;font-size: 14px;') TOTAL
                                v-layout(v-for='item in form.productos' align-start='', justify-start='', row='', fill-height='' style='border-bottom: 1px solid #dcd7d7;padding-bottom: 15px;padding-top:15px;')
                                    v-flex(xs8)
                                        span(style='font-size: 14px;')  {{item.art_des}}
                                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-size: 14px;')  {{item.cantNew}}
                                    v-flex(xs2 style='display: flex;justify-content: center;align-items: center;')
                                        span(style='font-size: 14px;')  {{item.reng_neto}}$

                            v-text-field(outline
                            readonly
                            style='margin-top: 20px;'
                            v-model="form.total"
                            prepend-inner-icon="description"
                            label="Total:")
                            
                            div(v-if='form.images && form.images.length > 0')
                                div(v-for='item in form.images')
                                    a(:href='ruta + item' target='_blank')
                                        img(:src='ruta + item' style='width: 425px;height: auto;')

                            v-text-field(outline
                              v-if='form.referencia'
                              readonly
                              v-model="form.referencia"
                              prepend-inner-icon="description"
                              label="Referencia:")

                            v-text-field(outline
                              v-if='form.motivo'
                              readonly
                              v-model="form.motivo"
                              prepend-inner-icon="description"
                              label="Motivo:")

                            v-textarea(outline
                              v-if='form.descripcion'
                              readonly
                              v-model="form.descripcion"
                              prepend-inner-icon="description"
                              label="Observación inicial:")

                            v-textarea(outline
                              v-if='form.observacionDisc'
                              readonly
                              v-model="form.observacionDisc"
                              prepend-inner-icon="description"
                              label="Observación (A discusión):")

                            v-textarea(outline
                              v-if='form.observacionDeses'
                              readonly
                              v-model="form.observacionDeses"
                              prepend-inner-icon="description"
                              label="Observación (Desestimado):")

                            v-textarea(outline
                              v-if='form.observacionReco'
                              readonly
                              v-model="form.observacionReco"
                              prepend-inner-icon="description"
                              label="Observación (Recolecta):")

                            v-textarea(outline
                              v-if='form.observacionReti'
                              readonly
                              v-model="form.observacionReti"
                              prepend-inner-icon="description"
                              label="Observación (Retirado):")

                            v-textarea(outline
                              v-if='form.observacionReci'
                              readonly
                              v-model="form.observacionReci"
                              prepend-inner-icon="description"
                              label="Observación (Recibido):")

                            v-textarea(outline
                              v-if='form.observacionApro'
                              readonly
                              v-model="form.observacionApro"
                              prepend-inner-icon="description"
                              label="Observación (Aprobado):")

                            v-textarea(outline
                              v-if='form.observacion'
                              readonly
                              v-model="form.observacion"
                              prepend-inner-icon="description"
                              label="Observación (Rechazo):")

                            v-textarea(outline
                              v-if='form.observacionSolc'
                              readonly
                              v-model="form.observacionSolc"
                              prepend-inner-icon="description"
                              label="Observación (Solucionado):")

                            v-textarea(outline
                              v-if='form.observacionCier'
                              readonly
                              v-model="form.observacionCier"
                              prepend-inner-icon="description"
                              label="Observación (Cerrado):")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='save("discusion")') A discusion
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("desestimar")') Desestimar
                                    v-btn(v-if='form.estatus === "A discusion"' style="background:green;border-radius:10px;", @click.native='save("recolecta")') Recolecta
                                    v-btn(v-if='form.estatus === "Recolecta"' style="background:green;border-radius:10px;", @click.native='save("retirado")') Retirado
                                    v-btn(v-if='form.estatus === "Retirado"' style="background:green;border-radius:10px;", @click.native='save("recibido")') Recibido
                                    v-btn(v-if='form.estatus === "Recibido"' style="background:green;border-radius:10px;", @click.native='save("aprobar")') Aprobar
                                    v-btn(v-if='form.estatus === "Recibido"' style="background:red;border-radius:10px;", @click.native='save("rechazar")') Rechazar
                                    v-btn(v-if='form.estatus === "Aprobado"' style="background:green;border-radius:10px;", @click.native='save("solucionado")') Solucionado
                                    v-btn(v-if='form.estatus === "Solucionado"' style="background:green;border-radius:10px;", @click.native='save("cerrado")') Cerrar proceso
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs4)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs4 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='filtros' v-model="seleccionFiltro" label="Estatus" @change='cambiarFiltro()')
            v-flex(xs4 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#ff9900' style='font-size: 1.70rem;') search
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'ElGocho-Devoluciones'" :sheetname="'sheetname'")
                img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Devoluciones
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.nro }}
            td {{ transform(props.item.fechaC)}}
            td(v-if='props.item.vendedor && props.item.vendedor.ven_des') {{ props.item.vendedor.ven_des }}
            td(v-else) N/A
            td(v-if='props.item.cliente && props.item.cliente.cli_des') {{ props.item.cliente.cli_des }}
            td(v-else) N/A
            td(v-if='props.item.factura && props.item.factura.nro_doc') {{ props.item.factura.nro_doc }}
            td(v-else) N/A
            td {{ props.item.total}}$
            td {{ props.item.estatus}}
            td.justify-start.layout.px-0
              v-tooltip(v-if='mod' bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') edit
                | Editar.
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem3(props.item)' v-on="on" color='teal') description
                | Exportar pdf.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import printJS from "print-js";
import { server, port } from "@/services/environment";
export default {
  name: "Devoluciones",
  data: vm => ({
    ruta: server + ":" + port,
    dates: [],
    loading: false,
    dialog3: false,
    dialog4: false,
    seleccionFiltro: "todos",
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "A discusión",
        value: "A discusion"
      },
      {
        text: "Desestimado",
        value: "Desestimado"
      },
      {
        text: "Recolecta",
        value: "Recolecta"
      },
      {
        text: "Retirado",
        value: "Retirado"
      },
      {
        text: "Recibido",
        value: "Recibido"
      },
      {
        text: "Aprobado",
        value: "Aprobado"
      },
      {
        text: "Rechazado",
        value: "Rechazado"
      },
      {
        text: "Solucionado",
        value: "Solucionado"
      },
      {
        text: "Cerrado",
        value: "Cerrado"
      }
    ],
    itemsF: [],
    dataExcel: [],
    columnsExcel: [
      {
        label: "Nro",
        field: "nro"
      },
      {
        label: "Fecha",
        field: "fechaC"
      },
      {
        label: "Vendedor",
        field: "vendedor"
      },
      {
        label: "Cliente",
        field: "cliente"
      },
      {
        label: "Factura",
        field: "factura"
      },
      {
        label: "Total",
        field: "total"
      },
      {
        label: "Estatus",
        field: "estatus"
      }
    ],
    pagination: {
      sortBy: "fechaC", // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
      nro: "",
      vendedor: "",
      papeleta: "",
      cliente: null,
      factura: null,
      productos: [],
      iva: 0,
      subtotal: 0,
      total: 0,
      images: [],
      referencia: "",
      motivo: "",
      observacion: "",
      observacionDisc: "",
      observacionDeses: "",
      observacionReco: "",
      observacionReti: "",
      observacionReci: "",
      observacionApro: "",
      observacionSolc: "",
      observacionCier: "",
      descripcion: "",
      estatus: "",
      fechaC: null
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Nro", value: "nro" },
      { text: "Fecha", value: "fechaC" },
      { text: "Vendedor", value: "vendedor.ven_des" },
      { text: "Cliente", value: "cliente.cli_des" },
      { text: "Factura", value: "factura.nro_doc" },
      { text: "Total", value: "total" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    defaultForm: {
      nro: "",
      vendedor: "",
      papeleta: "",
      cliente: null,
      factura: null,
      productos: [],
      iva: 0,
      subtotal: 0,
      total: 0,
      images: [],
      referencia: "",
      motivo: "",
      observacion: "",
      observacionDisc: "",
      observacionDeses: "",
      observacionReco: "",
      observacionReti: "",
      observacionReci: "",
      observacionApro: "",
      observacionSolc: "",
      observacionCier: "",
      descripcion: "",
      estatus: "",
      fechaC: null
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    dateRangeText() {
      let todos = [];
      let desde;
      let hasta;
      if (this.dates && this.dates[0]) {
        desde = this.formatDate(this.dates[0]);
        todos.push(desde);
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1]);
        todos.push(hasta);
      }
      return todos.join(" ~ ");
    }
  },
  watch: {
    dates(val) {
      if (val && val.length > 2) {
        let res = [];
        res.push(val[0]);
        res.push(val[2]);
        this.$nextTick(() => {
          this.dates = res;
        });
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = [];
        res.push(val[0]);
        this.$nextTick(() => {
          this.dates = res;
        });
      }
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
    }
  },
  created() {
    let desde = this.$moment()
      .subtract(1, "d")
      .format("YYYY-MM-DD");
    let hasta = this.$moment().format("YYYY-MM-DD");
    this.dates.push(desde);
    this.dates.push(hasta);
    this.verificacion();
    this.initialize();
  },
  methods: {
    editItem3(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      if (this.form.factura && this.form.factura.fec_emis)
        this.form.factura.fecha = this.$moment(
          this.form.factura.fec_emis
        ).format("DD-MM-YYYY");
      if (this.form.fechaC)
        this.form.fecha = this.$moment(this.form.fechaC).format("DD-MM-YYYY");
      this.form.arts = [];
      if (this.form.productos && this.form.productos.length > 0) {
        for (let i = 0; i < item.productos.length; i++) {
          const el = item.productos[i];
          let total = (
            parseFloat(el.cantNew) * parseFloat(el.prec_vta) +
            parseFloat(el.cantNew) *
              parseFloat(el.prec_vta) *
              (parseFloat(el.porc_imp) / 100)
          ).toFixed(2);
          this.form.arts.push({
            co_art: el.co_art.trim(),
            art_des: el.art_des.trim(),
            prec_vta: "$" + el.prec_vta.toFixed(2),
            cantNew: el.cantNew,
            total: "$" + total
          });
        }
      }
      this.form._id = item._id;
      this.dialog3 = true;
    },
    imprimirPdf() {
      printJS({
        printable: "printJS-form",
        type: "html",
        targetStyles: ["*"],
        maxWidth: "100%",
        css: "printPdf"
      });
    },
    close3() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog3 = false;
    },
    transform(date) {
      return this.$moment(date)
        .utc()
        .format("DD/MM/YYYY");
    },
    cambiarFiltro() {
      let data = this.seleccionFiltro;
      if (data) {
        this.resultados = [];
        this.dataExcel = [];
        let res = [];
        for (let i = 0; i < this.resultadosres.length; i++) {
          const el = this.resultadosres[i];
          if (data === "todos") {
            res.push(el);
            this.dataExcel.push({
              nro: el.nro,
              fechaC: this.$moment(el.fechaC).format("DD-MM-YYYY H:mm A"),
              vendedor: el.vendedor.ven_des,
              cliente: el.cliente.cli_des,
              factura: el.factura.nro_doc,
              total: el.total,
              estatus: el.estatus
            });
          } else if (el.estatus === data) {
            res.push(el);
            this.dataExcel.push({
              nro: el.nro,
              fechaC: this.$moment(el.fechaC).format("DD-MM-YYYY H:mm A"),
              vendedor: el.vendedor.ven_des,
              cliente: el.cliente.cli_des,
              factura: el.factura.nro_doc,
              total: el.total,
              estatus: el.estatus
            });
          }
        }
        this.$nextTick(() => {
          this.resultados = res;
        });
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminelgocho.permisos.length; i++) {
        if (
          this.$store.state.adminelgocho.permisos[i].ruta === "Devoluciones"
        ) {
          for (
            let j = 0;
            j < this.$store.state.adminelgocho.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminelgocho.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminelgocho.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminelgocho.permisos[i].accion[j] ===
              "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    buscarFecha() {
      this.dialog4 = true;
      let hasta = this.dates && this.dates[1] ? this.dates[1] : null;
      if (this.dates && this.dates[0]) {
        Api.get("devoluciones/admin?desde=" + this.dates[0] + "&hasta=" + hasta)
          .then(res => {
            this.dialog4 = false;
            this.resultados = [];
            this.resultadosres = [];
            this.dataExcel = [];
            if (res.data && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const el = res.data[i];
                if (typeof el.cliente === "string")
                  el.cliente = JSON.parse(el.cliente);
                if (typeof el.productos === "string")
                  el.productos = JSON.parse(el.productos);
                if (typeof el.factura === "string")
                  el.factura = JSON.parse(el.factura);
                this.resultados.push(el);
                this.resultadosres.push(el);
                this.dataExcel.push({
                  nro: el.nro,
                  fechaC: this.$moment(el.fechaC).format("DD-MM-YYYY H:mm A"),
                  vendedor: el.vendedor.ven_des,
                  cliente: el.cliente.cli_des,
                  factura: el.factura.nro_doc,
                  total: el.total,
                  estatus: el.estatus
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
            this.dialog4 = false;
          });
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10);
      this.dateFormatted = this.formatDate(
        new Date().toISOString().substr(0, 10)
      );
      this.dates = [];
      let desde = this.$moment()
        .subtract(1, "d")
        .format("YYYY-MM-DD");
      let hasta = this.$moment().format("YYYY-MM-DD");
      this.dates.push(desde);
      this.dates.push(hasta);
      this.dataExcel = [];
      Api.get(
        "devoluciones/admin?desde=" + this.dates[0] + "&hasta=" + this.dates[1]
      ).then(res => {
        this.resultados = [];
        this.resultadosres = [];
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string")
              el.cliente = JSON.parse(el.cliente);
            if (typeof el.productos === "string")
              el.productos = JSON.parse(el.productos);
            if (typeof el.factura === "string")
              el.factura = JSON.parse(el.factura);
            this.resultados.push(el);
            this.resultadosres.push(el);
            console.log(el);
            this.dataExcel.push({
              nro: el.nro,
              fechaC: this.$moment(el.fechaC).format("DD-MM-YYYY H:mm A"),
              vendedor: el.vendedor.ven_des,
              cliente: el.cliente.cli_des,
              factura: el.factura.nro_doc,
              total: el.total,
              estatus: el.estatus
            });
          }
        }
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    save(item) {
      let info = {
        _id: this.form._id,
        estatus: ""
      };
      if (item == "discusion") info.estatus = "A discusion";
      if (item == "desestimar") info.estatus = "Desestimar";
      if (item == "recolecta") info.estatus = "Recolecta";
      if (item == "retirado") info.estatus = "Retirado";
      if (item == "recibido") info.estatus = "Recibido";
      if (item == "aprobar") info.estatus = "Aprobado";
      if (item == "rechazar") info.estatus = "Rechazado";
      if (item == "solucionado") info.estatus = "Solucionado";
      if (item == "cerrado") info.estatus = "Cerrado";
      this.$swal
        .fire({
          title: "Observación",
          input: "text",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          denyButtonText: "Omitir",
          reverseButtons: true
        })
        .then(result => {
          console.log(result);
          if (result.isDenied) {
            this.loading = true;
            Api.put("devoluciones", info)
              .then(() => {
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
                this.buscarFecha();
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
              });
          } else if (result.isDismissed) {
            console.log("paso cancelar");
          } else if (result.isConfirmed) {
            if (result.value) {
              if (item == "discusion") info.observacionDisc = result.value;
              if (item == "desestimar") info.observacionDeses = result.value;
              if (item == "recolecta") info.observacionReco = result.value;
              if (item == "retirado") info.observacionReti = result.value;
              if (item == "recibido") info.observacionReci = result.value;
              if (item == "aprobar") info.observacionApro = result.value;
              if (item == "aprobar") info.observacionApro = result.value;
              if (item == "rechazar") info.observacion = result.value;
              if (item == "solucionado") info.observacionSolc = result.value;
              if (item == "cerrado") info.observacionCier = result.value;
              this.loading = true;
              Api.put("devoluciones", info)
                .then(() => {
                  this.form = Object.assign({}, this.defaultForm);
                  this.dialog = false;
                  this.$swal.fire(
                    "Felicidades.!",
                    "Modificación realizada exitosamente.",
                    "success"
                  );
                  this.loading = false;
                  this.buscarFecha();
                })
                .catch(err => {
                  console.log(err);
                  this.loading = false;
                  this.$swal.fire(
                    "Oops...",
                    "Error encontrado, verifique los datos o llame al administrador.",
                    "error"
                  );
                });
            } else {
              this.$swal.fire(
                "¡Atención!",
                "Debe ingresar la observación.",
                "error"
              );
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.printPdf {
  @page :footer {
    display: none;
  }

  @page :header {
    display: none;
  }
}
.borderTb {
  border: 1px solid;
  text-align: center;
  width: 160px;
}
.withTd {
  width: 160px;
}
.textGrn {
  width: 100%;
  text-align: center;
}
.withTd2 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
}
.withTd4 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
  background-color: #ff9900;
}
.withTd3 {
  padding: 4px;
  font-weight: bold;
}
.withTd5 {
  font-weight: bold;
}
.paddText {
  padding-right: 10px;
  font-size: 14px;
  font-weight: bold;
}
.divRect {
  width: 100px;
  height: 30px;
  border: 2px solid;
}
.divPrin {
  display: flex;
  align-items: center;
}
.divProd {
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divCli {
  margin-top: 20px;
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#printJS-form {
  table,
  th,
  td {
    border-collapse: collapse;
  }
}
</style>
